import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons';
import React from 'react';

export type MainTabParamList = {
  EcranAccueil: undefined;
  ListeClients: undefined;
  ParkVehicules: undefined;
  ListeCommandes: undefined;
  GestionFinanciere: undefined;
  GestionStock: undefined;
  GestionUtilisateurs: undefined;
  Parametres: undefined;
  HistoriqueActions: undefined;
};

export type NavIconName = React.ComponentProps<typeof MaterialCommunityIcons>['name'];

export type NavItem = {
  name: keyof MainTabParamList;
  label: string;
  /** Shorter label for the mobile bottom tab bar. */
  shortLabel?: string;
  icon: NavIconName;
  activeIcon: NavIconName;
  adminOnly?: boolean;
  /** Shown directly in the mobile bottom tab bar (the others live in the "Menu" sheet). */
  mobileTab?: boolean;
};

export const NAV_ITEMS: NavItem[] = [
  { name: 'EcranAccueil', label: 'Tableau de bord', shortLabel: 'Accueil', icon: 'home-variant-outline', activeIcon: 'home-variant', mobileTab: true },
  { name: 'ListeClients', label: 'Clients', icon: 'account-group-outline', activeIcon: 'account-group', mobileTab: true },
  { name: 'ParkVehicules', label: 'Véhicules', icon: 'car-outline', activeIcon: 'car', mobileTab: true },
  { name: 'ListeCommandes', label: 'Commandes', icon: 'file-document-outline', activeIcon: 'file-document', mobileTab: true },
  { name: 'GestionFinanciere', label: 'Finances', icon: 'chart-box-outline', activeIcon: 'chart-box', adminOnly: true },
  { name: 'GestionStock', label: 'Stock', icon: 'package-variant-closed', activeIcon: 'package-variant-closed' },
  { name: 'GestionUtilisateurs', label: 'Utilisateurs', icon: 'account-cog-outline', activeIcon: 'account-cog', adminOnly: true },
  { name: 'Parametres', label: 'Paramètres', icon: 'cog-outline', activeIcon: 'cog', adminOnly: true },
  { name: 'HistoriqueActions', label: 'Historique', icon: 'history', activeIcon: 'history', adminOnly: true },
];

export function visibleNavItems(isAdmin: boolean) {
  return NAV_ITEMS.filter((item) => !item.adminOnly || isAdmin);
}

export const roleLabel = (role?: string | null) => {
  if (role === 'ROLE_SUPER_ADMIN') return 'Super administrateur';
  if (role === 'ROLE_ADMIN') return 'Administrateur';
  if (role === 'ROLE_SUPER_AGENT') return 'Super agent';
  if (role === 'ROLE_AGENT') return 'Agent';
  return 'Utilisateur';
};
